import Papa from 'papaparse';

export const exportToCSV = (leads, filename = 'payday-leads') => {
  // Prepare data for CSV export
  const csvData = leads.map(lead => ({
    'First Name': lead.firstName || '',
    'Last Name': lead.lastName || '',
    'Email': lead.email || '',
    'Phone': lead.phone || '',
    'Date of Birth': lead.dateOfBirth || '',
    'Loan Type': lead.loanType || 'Payday Loan',
    'Loan Amount': lead.loanAmount || '',
    'Credit Score': lead.creditScore || lead.cibilScore || '',
    'Employment Type': lead.employmentType || '',
    'Monthly Income': lead.monthlyIncome || '',
    'Status': lead.status || '',
    'Source': lead.submissionSource || '',
    'Created At': lead.createdAt ? (typeof lead.createdAt.toLocaleString === 'function' ? lead.createdAt.toLocaleString() : new Date(lead.createdAt).toLocaleString()) : ''
  }));

  // Convert to CSV
  const csv = Papa.unparse(csvData);

  // Create and download file
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${filename}-${Date.now()}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
